import './instrument';
import { merge } from 'lodash';
import { createRoot } from 'react-dom/client';
import { resolveServiceUrls } from './helpers/service-urls';

merge(
  window.ReactAppEnv,
  // Local dev environment overrides can be read from .env.local
  {
    client: {
      version: import.meta.env.VITE_CLIENT_VERSION,
      build: import.meta.env.VITE_CLIENT_BUILD,
    },
    api: {
      ...resolveServiceUrls(import.meta.env, window.ReactAppEnv.api),
      uri: import.meta.env.VITE_API_SERVER_URI,
    },
    auth: {
      UserPoolId: import.meta.env.VITE_AUTH_USER_POOL_ID,
      ClientId: import.meta.env.VITE_AUTH_CLIENT_ID,
    },
  },
);

Promise.all([import('./app/AppPreload')]).then(
  ([{ App, createHistory, Router }]) => {
    const history = createHistory();

    // No onUncaughtError, deliberately. React's default reports an uncaught
    // render error through window.reportError, which Sentry's global handler,
    // PostHog's error tracking and the console all pick up. A custom handler
    // replaces that, so every one of them would have to be wired by hand.
    createRoot(document.getElementById('root')).render(
      <Router history={history}>
        <App />
      </Router>,
    );
  },
);
